import { openCookiePreferences } from "@design-system/atoms";
import { trans } from "@mongez/localization";
import { useCookieConsent } from "../hooks";

export interface CookieConsent {
  essential: boolean;
  analytics: boolean;
  functional: boolean;
  marketing: boolean;
}

export function CookieConsentBanner() {
  const { handleRejectNonEssential, handleAcceptAll, showBanner } =
    useCookieConsent();

  const handleManagePreferences = () => {
    openCookiePreferences();
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t-2 border-bright-orange bg-white shadow-2xl backdrop-blur-sm">
      <div className="container mx-auto px-4 py-4 sm:py-6">
        <div className="flex flex-col gap-4 sm:gap-6 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
          <div className="flex-1">
            <div className="flex items-center gap-3 sm:gap-4">
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-bright-orange to-steel shadow-lg ring-2 ring-bright-orange ring-opacity-20 sm:h-12 sm:w-12">
                <svg
                  className="h-5 w-5 text-white sm:h-7 sm:w-7"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="mb-1 text-lg font-bold leading-tight text-primary sm:mb-2 sm:text-xl lg:text-2xl">
                  {trans("cookieBanner.title")}
                </h3>
                <p className="text-sm leading-relaxed text-gray-600 sm:text-base">
                  {trans("cookieBanner.description")}
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 sm:gap-3 lg:flex-shrink-0 lg:flex-row">
            <button
              onClick={handleRejectNonEssential}
              className="rounded-full border border-gray-300 bg-white px-4 py-2.5 text-xs font-medium uppercase text-gray-700 transition-all duration-200 hover:border-gray-400 hover:bg-gray-50 hover:shadow-md sm:px-6 sm:py-3 sm:text-sm"
            >
              {trans("cookieBanner.rejectNonEssential")}
            </button>
            <button
              onClick={handleManagePreferences}
              className="rounded-full border border-bright-orange bg-white px-4 py-2.5 text-xs font-medium uppercase text-bright-orange transition-all duration-200 hover:bg-bright-orange hover:text-white hover:shadow-md sm:px-6 sm:py-3 sm:text-sm"
            >
              {trans("cookieBanner.managePreferences")}
            </button>
            <button
              onClick={handleAcceptAll}
              className="rounded-full bg-gradient-to-r from-bright-orange to-steel px-6 py-2.5 text-xs font-medium uppercase text-white transition-all duration-200 hover:scale-105 hover:shadow-lg sm:px-8 sm:py-3 sm:text-sm"
            >
              {trans("cookieBanner.acceptAll")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
